import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { FieldContext } from './FieldContext';
import { ChildrenBucket, HasChildQuery } from "../query_dsl";

var get = require("lodash/get");

export var ChildrenFieldContext =
/*#__PURE__*/
function (_FieldContext) {
  _inherits(ChildrenFieldContext, _FieldContext);

  function ChildrenFieldContext(fieldOptions) {
    var _this;

    _classCallCheck(this, ChildrenFieldContext);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChildrenFieldContext).call(this, fieldOptions));

    if (!get(_this.fieldOptions, "options.childType")) {
      throw new Error("fieldOptions type:children requires options.childType");
    }

    return _this;
  }

  _createClass(ChildrenFieldContext, [{
    key: "getAggregationPath",
    value: function getAggregationPath() {
      return "inner";
    }
  }, {
    key: "wrapAggregations",
    value: function wrapAggregations() {
      for (var _len = arguments.length, aggregations = new Array(_len), _key = 0; _key < _len; _key++) {
        aggregations[_key] = arguments[_key];
      }

      return [ChildrenBucket.apply(void 0, ["inner", this.fieldOptions.options.childType].concat(aggregations))];
    }
  }, {
    key: "wrapFilter",
    value: function wrapFilter(filter) {
      return HasChildQuery(this.fieldOptions.options.childType, filter, this.fieldOptions.options);
    }
  }]);

  return ChildrenFieldContext;
}(FieldContext);